import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { AppState } from '../../../../store/models/app-state';
import { BaseAutocompleteSuggestionType } from '../pool-autocomplete-list';
import { LocalizedPosition } from '../../../models/localized-position';
import { PoolFormAutocompleteList } from '../../abstract/form-autocomplete-list';
import { localizedPositionsSelector } from '../../../selectors/positions-selectors';

export interface PartialPosition extends BaseAutocompleteSuggestionType {
    name: string;
}

interface PoolPositionAutocompleteListProps {
    positions: LocalizedPosition[];
}

class PoolPositionAutocompleteListBase extends PoolFormAutocompleteList<
    LocalizedPosition,
    PartialPosition,
    PoolPositionAutocompleteListProps
> {
    public override label = this.props.label || <FormattedMessage id="app.header.position" />;
    public override hideId = true;

    public getSuggestionValue = (suggestion: PartialPosition) => suggestion && suggestion.name;

    public override componentDidMount(): void {
        this.setState({ items: this.props.positions });
    }

    public override async handleValueChanged(search: string) {
        const items = this.props.positions.filter(position =>
            position.name?.toLowerCase().includes(search.toLowerCase())
        );
        this.setState({ items });
    }

    public getPartial = (items: LocalizedPosition[]): PartialPosition[] => {
        return items.map(Position => {
            return {
                id: Position.id,
                name: Position.name,
                dummy: '', // HACK: We need a dummy value to render the list correctly.
            };
        });
    };
}

const mapStateToProps = (state: AppState) => ({
    positions: localizedPositionsSelector(state),
});

export const PoolPositionAutocompleteList = connect(mapStateToProps, {})(PoolPositionAutocompleteListBase);
